import React from 'react';
import { Container, Button } from 'react-bootstrap';
import './Hero.css';

function Hero({ onInfoClick, onContactClick }) {
  return (
    <section className="hero-section">
      
      {/* 🔥 LCP IMAGE */}
      <img
        src="/hero-bg.jpg"
        alt="Hilal Makine"
        className="hero-bg"
        fetchpriority="high"
        loading="eager"
        decoding="async"
      />

      {/* Overlay */}
      <div className="hero-overlay"></div>

      <Container className="text-center hero-content">
        <h1 className="hero-title">Hilal Makine</h1>
        <p className="hero-subtitle">
          Profesyonel mekanik çözümler, güvenilir hizmet.
        </p>

        <div className="hero-buttons mt-4">
          <Button
            variant="primary"
            size="lg"
            className="me-3"
            onClick={onInfoClick}
          >
            Hakkımızda
          </Button>

          <Button
            variant="outline-light"
            size="lg"
            onClick={onContactClick}
          >
            İletişime Geç
          </Button>
        </div>
      </Container>
    </section>
  );
}

export default Hero;
